import { FC } from "react";
import _ from "lodash";
import moment from "moment";
import { GetPromotion_getPromotion } from "_graphql/queries/__generated__/GetPromotion";

type Props = {
  promotion: GetPromotion_getPromotion | null | undefined;
};

const PromotionView: FC<Props> = ({ promotion }) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div>
        <span className="text-xs font-light">Promotion Information</span>
        <div className="grid grid-cols-3 gap-6 mt-2">
          <div className="col-span-3">
            <span className="block text-sm font-light text-gray-700">
              Name
            </span>
            <div className="mt-1 block w-full sm:text-sm font-medium">
              {promotion?.name || "N/A"}
            </div>
          </div>
          <div className="col-span-3">
            <span className="block text-sm font-light text-gray-700">
              Description
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {promotion?.description || "N/A"}
            </div>
          </div>
          <div className="col-span-1">
            <span className="block text-sm font-light text-gray-700">
              Type
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {_.startCase(promotion?.type || "") || "N/A"}
            </div>
          </div>
          <div className="col-span-1">
            <span className="block text-sm font-light text-gray-700">
              Status
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {_.startCase(promotion?.status || "") || "N/A"}
            </div>
          </div>
          <div className="col-span-1">
            <span className="block text-sm font-light text-gray-700">
              Created By
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {promotion?.createdBy?.employee_first_name && promotion?.createdBy?.employee_last_name
                ? `${promotion.createdBy.employee_first_name} ${promotion.createdBy.employee_last_name}`
                : "N/A"}
            </div>
          </div>
          <div className="col-span-1">
            <span className="block text-sm font-light text-gray-700">
              Start Date and Time
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {promotion?.start_datetime
                ? moment(promotion.start_datetime).format("MMMM Do YYYY, h:mm a")
                : "N/A"}
            </div>
          </div>
          <div className="col-span-1">
            <span className="block text-sm font-light text-gray-700">
              End Date and Time
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {promotion?.end_datetime
                ? moment(promotion.end_datetime).format("MMMM Do YYYY, h:mm a")
                : "N/A"}
            </div>
          </div>
          {promotion?.assets && (
            <div className="col-span-3">
              <span className="block text-sm font-light text-gray-700 mb-3">
                Assets
              </span>
              <div className="space-y-4">
                {promotion.assets.large && promotion.assets.large.length > 0 && (
                  <div>
                    <h4 className="text-xs font-medium text-gray-600 mb-2">Large Assets</h4>
                    <div className="grid grid-cols-2 gap-4">
                      {promotion.assets.large.map((asset, index) => (
                        <div key={`large-${index}`} className="flex flex-col">
                          <img
                            src={asset || ""}
                            alt={`Large asset ${index + 1}`}
                            className="object-cover h-32 w-full rounded-md border"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {promotion.assets.medium && promotion.assets.medium.length > 0 && (
                  <div>
                    <h4 className="text-xs font-medium text-gray-600 mb-2">Medium Assets</h4>
                    <div className="grid grid-cols-3 gap-4">
                      {promotion.assets.medium.map((asset, index) => (
                        <div key={`medium-${index}`} className="flex flex-col">
                          <img
                            src={asset || ""}
                            alt={`Medium asset ${index + 1}`}
                            className="object-cover h-24 w-full rounded-md border"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {promotion.assets.small && promotion.assets.small.length > 0 && (
                  <div>
                    <h4 className="text-xs font-medium text-gray-600 mb-2">Small Assets</h4>
                    <div className="grid grid-cols-4 gap-4">
                      {promotion.assets.small.map((asset, index) => (
                        <div key={`small-${index}`} className="flex flex-col">
                          <img
                            src={asset || ""}
                            alt={`Small asset ${index + 1}`}
                            className="object-cover h-16 w-full rounded-md border"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {(!promotion?.assets ||
            (!promotion.assets.large?.length &&
              !promotion.assets.medium?.length &&
              !promotion.assets.small?.length)) && (
              <div className="col-span-3">
                <span className="block text-sm font-light text-gray-700">
                  Assets
                </span>
                <div className="mt-1 text-sm font-light text-gray-500">
                  No assets available
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default PromotionView;
